import React from 'react'
import styled from 'styled-components'
import format from 'dateformat'

import { CopyToClipboardButton } from 'live/components/ui/CopyText'
import ActionToggle from 'live/components/ui/action-toggle'

import { URL_DOWNLOAD, URL_DOWNLOAD_PUBLIC } from '../constants'
import { downloadFile } from '../functions/downloadFile'
import { deleteFile } from '../functions/deleteFile'
import { TableProps } from '../interface'
import { PermissionsAPI, checkPermission } from '../api/permissions'

const order = {
    name: 'File Name',
    type: 'File Type',
    username: 'Uploaded By',
    timestamp: 'Upload Date',
    expirationDate: 'Expiration Date',
    isPublic: 'Visibility'
}

export const TableList = ({
    files,
    setFiles,
    directory = null,
    deleteFileByUid = deleteFile,
    columns = order,
    offset,
    totalFiles,
    loadMore = false,
    fcLoadFiles
}: TableProps) => {
    const LABELS = Object.values(columns)
    const hasDownloadPermission = checkPermission(PermissionsAPI.DOWNLOAD_PRIVATE_FILES)

    return (
        <Div>
            <div
                style={{
                    height: loadMore ? `calc(100% - 70px)` : '100%',
                    overflowY: 'auto'
                }}
            >
                <Table>
                    <thead>
                        <tr>
                            {LABELS.map(label => {
                                return <th>{label}</th>
                            })}
                            <th> </th>
                        </tr>
                    </thead>

                    <tbody>
                        {files.map(file => {
                            if(!file) return null
                            const { name, type, username, timestamp, isPublic, expirationDate } = file

                            return (
                                <tr>
                                    <td>
                                        <File onClick={() => downloadFile(file, directory)}>
                                            {/* {fitName(file.name, 24)} */}
                                            {name}
                                        </File>
                                    </td>
                                    <td>{type}</td>
                                    <td>{username}</td>
                                    <td>{format(new Date(Number(timestamp)), 'dd/mm/yyyy, HH:MM:ss')}</td>
                                    <td>
                                        {expirationDate
                                            ? format(new Date(Number(expirationDate)), 'dd/mm/yyyy, HH:MM:ss')
                                            : '--'}
                                    </td>
                                    <td>{isPublic == 'true' ? 'Public' : 'Private'}</td>
                                    <td>
                                        <div className="table-actions">
                                            {hasDownloadPermission ? (
                                                <i
                                                    className="far fa-download"
                                                    onClick={() => downloadFile(file, directory)}
                                                />
                                            ) : null}

                                            <CopyToClipboardButton
                                                // @ts-ignore
                                                style={{ color: '#37A3EF' }}
                                                copyText={
                                                    isPublic == 'true'
                                                        ? `${URL_DOWNLOAD_PUBLIC}/${file.uuid}`
                                                        : `${URL_DOWNLOAD}${directory ? `/${directory}` : ''}/${
                                                              file.uuid
                                                          }`
                                                }
                                            />

                                            <i
                                                style={{ color: '#C43535' }}
                                                className="far fa-trash-alt"
                                                onClick={() => deleteFileByUid(file, setFiles, directory)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>

            {loadMore ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}
                >
                    <p
                        style={{
                            padding: '5px'
                        }}
                    >
                        Showing {files.length} files of {totalFiles}
                    </p>
                    <a className="btn btn-primary col-md-3 col-center-block" onClick={() => fcLoadFiles()}>
                        <i className="fa fa-arrow-circle-down" />
                        Load more {offset}
                    </a>
                </div>
            ) : null}
        </Div>
    )
}

const Div = styled.div`
    height: 60vh;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    margin-top: 0.5rem;
    z-index: 11;
    color: var(--gray-600);

    &::-webkit-scrollbar {
        width: 5px;
        height: 10px;
        -webkit-border-radius: 16px;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: #ffffff;
        -webkit-border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: #666;
        -webkit-border-radius: 3px;
    }
`

const Table = styled.table`
    overflow-y: scroll;
    width: 100%;
    font-family: var(--font-semibold);

    border: 1px solid var(--gray-400);

    tr {
        border-bottom: 1px solid var(--gray-400);
    }

    tbody tr {
        &:hover {
            background-color: var(--blue-200);
            transition: 0.5s;

            td .table-actions {
                visibility: visible;
            }
        }
    }

    th {
        font-size: 12px;
        color: var(--gray-600);
        font-style: normal;
        text-transform: bold;
        background-color: var(--gray-200);
    }

    tr,
    td,
    th {
        padding: 16px;
    }

    td .table-actions {
        visibility: hidden;
        display: flex;
        justify-content: space-around;
        align-items: center;

        i {
            cursor: pointer;
            color: #37a3ef;
            font-size: 15px;
        }
    }

    tbody {
        overflow-y: scroll;
        height: 100%;
        width: 100%;
    }
`

const File = styled.span`
    color: var(--blue-500);
    font-size: 13px;
    cursor: pointer;
`
